import AmbPayment from './AmbPayment'

export default AmbPayment
